module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_saitama-19ae1eb1d9c67d66629258c7e3575759.png";